export default class StructureEditorInterface {
  // Returns Promise - state readiness
  state = null;

  static _abstract() {
    Logger.error('Not implemented abstract method!');
  }

  getData() {
    this.constructor._abstract();
  }

  isEmpty() {
    this.constructor._abstract();
  }

  clear() {
    this.constructor._abstract();
  }

  loadStructure() {
    this.constructor._abstract();
  }

  // Separate from loadStructure because the editors disagree on what loadStructure accepts:
  // Marvin sniffs any format, ChemDraw only takes MOL/RXN text.
  loadSmiles() {
    this.constructor._abstract();
  }

  onChange() {
    this.constructor._abstract();
  }

  onLoaded() {
    this.constructor._abstract();
  }
}
